'use strict';
import angular from 'angular';

angular.module('currentUser.services').factory('VendorRestricted', ['Role', function (Role) {
    return Role.newFrozenInstance()
}]);